import { metricNumerals, type NumeralKind } from '../render/metric-numerals';

export function MetricNumerals({ value, kind }: { value: string; kind: NumeralKind }) {
  const parts = metricNumerals(value, kind);
  return <span className="social-numerals" aria-label={value}><span aria-hidden="true">{parts.primary}
    {parts.extended && <span className="extended-numerals">{parts.extended}</span>}</span></span>;
}
